<template>
	<div class="Intelligent-equipment-management-system-list">
		<div class="Intelligent-equipment-management-system-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">IEMS（Intelligent Equipment Management System）</span>
			</div>

			<div class="list">
				<ul class="tt">
					<li><img :src="solution_image_01" alt="Xhorse"/></li>
					<li><img :src="solution_image_02" alt="Xhorse"/></li>
				</ul>
				<ul class="dd">
					<li><h3>Main features:</h3>
						<p>
							It can control the overall efficiency of equipment in real time, achieve shutdown warning through big data analysis, automatically notify maintenance and calibration, query equipment status in real time, and easily integrate various types of equipment and cloud knowledge base.</p>
					</li>
					<li><h3>Function:</h3>
						<p>
							Equipment information management, equipment preventive maintenance, calibration, machine status visual monitoring, cloud repair call and repair function, real-time control of consumables and spare parts, web interface action device, asset integration management, management report.</p>
					</li>
					<li><h3>Real time and accurate control of equipment comprehensive efficiency:</h3>
						<p>
							Intuitive management interface is used to control all kinds of reports in real time, such as equipment operation rate, OEE, equipment preventive maintenance report, etc. in case of abnormal conditions, real-time review and improvement countermeasures can be formulated.</p>
					</li>
					<li><h3>Achieve shutdown warning through big data analysis:</h3>
						<p>
							Through the equipment data monitoring and production information integration, comparison and analysis, find out the data model before the equipment abnormal, prevent the production line shutdown caused by shutdown.</p>
					</li>
					<li><h3>The system automatically informs the maintenance and calibration schedule:</h3>
						<p>
							The system allows users to schedule machine maintenance or instrument calibration in advance, and actively remind the schedule time in advance.</p>
					</li>
					<li><h3>Real time query of equipment status:</h3>
						<p>
							The system can be used for users to query the equipment maintenance and repair history data at any time, and master the equipment use and maintenance status in real time.</p>
					</li>
					<li><h3>Easy integration of devices:</h3>
						<p>
							Developers can send the real-time status and test data back to IEMs platform system through OPC, MSMQ or API.</p>
					</li>
					<li><h3>Cloud knowledge base:</h3>
						<p>
							All call for repair data, maintenance data and machine status data will be automatically uploaded to the cloud knowledge base, so that users can clearly grasp the complete equipment resume.</p>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>

    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_intellgent_03.png'
    import solution_image_02 from '@/assets/resource/images/solution/image_solutions_intellgent_04.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01,
                solution_image_02: solution_image_02,
            };
        }
    }

</script>

<style scoped="">
	.dd > li > h3, .dd > li > p {
		width: 100%;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.75rem;
	}

	.dd > li {
		width: 100%;
		margin-bottom: 1.375rem;
	}

	.dd {
		height: 57.75rem;
		margin-top: 2.75rem;
	}

	.tt img {
		width: 100%;
		height: 100%;
	}

	.tt > li {
		width: 29.75rem;
		height: 20rem;
		float: left;
	}

	.tt > li:nth-child(2) {
		width: calc((100% - 29.75rem - 2rem));
		margin-left: 2rem;
	}

	.tt {
		height: 20rem;
	}

	.dd {
		height: 57.75rem;
	}

	.list > .tt, .list > .dd {
		width: 100%;
	}

	.Intelligent-equipment-management-system-con {
		width: 61.5rem;
		border: none;
		margin-left: 0px;
	}

	.Intelligent-equipment-management-system-list {
		width: 100%;
		height: 84.375rem;
		border: none;
	}

	.list {
		width: 54.5rem;
		height: 80.5rem;
		border: none;
		margin-left: 7rem;
	}

	.x-tit-con {
		font-size: 1.5rem;
		color: #3B3A38;
		line-height: 3.25rem;
	}

	.title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
	}

	.x-icon-keys {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_solutions.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-intelligent-equipment-management-system.vue